import React from 'react';
import KnowledgeHubCreateCategory from './main';
import NavDriver from './nav-driver';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<NavDriver>
		{({ isOpen, onClose }) => <KnowledgeHubCreateCategory isOpen={isOpen} onClose={onClose} />}
	</NavDriver>
);
